'use client';

import React, { useEffect } from 'react';

import SimpleBar, { Props as SimpleBarProps } from 'simplebar-react';

export const Scrollbar = React.forwardRef<any, SimpleBarProps>(({ style, ...props }, ref) => {
  useEffect(() => {
    // Dynamically load CSS only on client, avoid render blocking
    import('simplebar-react/dist/simplebar.min.css');
  }, []);

  return (
    <SimpleBar
      {...props}
      ref={ref}
      style={{
        maxHeight: '100%',
        minHeight: 0,
        ...style,
      }}
    />
  );
});
